export default __webpack_public_path__ + "static/HU_Con_112_PCG1024_4-f5f2fa43a32e33449aa46f8f537cadce.jpg";